import COMPANY_LOGO_PATH from '../assets/images/new_magma_logo.svg'
export const APP_BACKEND_API_URL = 'https://buddy.magmainsurance.com/magma_api/magma/'
export const SUCCESS_STATUS = 'SUCCESS';
export const ERROR_STATUS = 'FAILURE';
export const UNAUTHORIZE_STATUS = 401;
export const UNAUTHENTICATE_STATUS = 'TOKEN_EXPIRED';
export const PAGINATION_LIMIT = 10;

export const PORTAL_URL = 'https://buddy.magmainsurance.com'
export const COMPANY_NAME = 'Magma'
export {COMPANY_LOGO_PATH}

export const HEADER_DATA = () => {
    return {
        'Content-Type': 'application/json',
        'x-access-token': getToken()
    }
}

const getToken = async () => {
    return await localStorage.getItem('_token')
}